import { c as _c } from "react/compiler-runtime";
import Chip from '@cc-shopping/ui/composites/Chip';
import { Box, Container, Stack, type SxProps } from '@mui/material';
import { startTransition, useCallback } from 'react';
import { useShallow } from 'zustand/shallow';
import { useOffersFilterStore } from '../../store/Context';
import { useFiltersAnalytics } from '../../store/hooks/useFiltersAnalytics';
import type { OffersFilterStoreState } from '../../store/types';
import type { DesktopFilterOptions } from '../hooks/useDesktopFilterOptions';
import { CardFeaturesFilter } from './Filters/CardFeatures';
import { CreditRangeFilter } from './Filters/CreditRange';
import { IssuersFilter } from './Filters/Issuers';
import { SortByFilter } from './Filters/SortBy';
type FiltersStickyProps = {
  filterOptions: DesktopFilterOptions;
  ref?: React.Ref<HTMLElement>;
  onChange?: () => void;
};
const FILTER_BOX_STYLES: SxProps = {
  flex: '1 1 0',
  // use minWidth: 0 to allow the box to shrink if the content is smaller than the box
  minWidth: 0
};
export function FiltersSticky(t0) {
  const $ = _c(34);
  const {
    filterOptions,
    ref,
    onChange
  } = t0;
  const {
    handleClearFilters,
    handleApplyFilters,
    selectedNonDefaultFilters
  } = useOffersFilterStore(useShallow(_temp));
  const {
    fireClearAllEvents
  } = useFiltersAnalytics();
  const hasActiveFilters = selectedNonDefaultFilters.length > 0;
  let t1;
  if ($[0] !== fireClearAllEvents || $[1] !== handleApplyFilters || $[2] !== handleClearFilters || $[3] !== onChange) {
    t1 = () => {
      startTransition(() => {
        handleClearFilters();
        handleApplyFilters();
        onChange?.();
      });
      fireClearAllEvents();
    };
    $[0] = fireClearAllEvents;
    $[1] = handleApplyFilters;
    $[2] = handleClearFilters;
    $[3] = onChange;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleClearAll = t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      backgroundColor: "white",
      boxShadow: "rgba(0, 0, 0, 0.15) 0px 4px 4px 0px",
      zIndex: 100,
      py: 3.5
    };
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      px: "var(--padding-x)"
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      gap: 2
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== filterOptions || $[9] !== onChange) {
    t5 = <Box sx={FILTER_BOX_STYLES}><CardFeaturesFilter options={filterOptions} onAfterChange={onChange} /></Box>;
    $[8] = filterOptions;
    $[9] = onChange;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== filterOptions || $[12] !== onChange) {
    t6 = <Box sx={FILTER_BOX_STYLES}><CreditRangeFilter options={filterOptions} onAfterChange={onChange} /></Box>;
    $[11] = filterOptions;
    $[12] = onChange;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== filterOptions || $[15] !== onChange) {
    t7 = <Box sx={FILTER_BOX_STYLES}><IssuersFilter options={filterOptions} onAfterChange={onChange} /></Box>;
    $[14] = filterOptions;
    $[15] = onChange;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== filterOptions || $[18] !== onChange) {
    t8 = <Box sx={FILTER_BOX_STYLES}><SortByFilter options={filterOptions} onAfterChange={onChange} /></Box>;
    $[17] = filterOptions;
    $[18] = onChange;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      flex: "0 0 auto"
    };
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      minHeight: "40px"
    };
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const t11 = !hasActiveFilters;
  let t12;
  if ($[22] !== handleClearAll || $[23] !== t11) {
    t12 = <Box sx={t9}><Chip sx={t10} label="Clear all" onClick={handleClearAll} disabled={t11} /></Box>;
    $[22] = handleClearAll;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== t5 || $[27] !== t6 || $[28] !== t7 || $[29] !== t8) {
    t13 = <Container disableGutters={true} sx={t3}><Stack direction="row" sx={t4}>{t5}{t6}{t7}{t8}{t12}</Stack></Container>;
    $[25] = t12;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== ref || $[32] !== t13) {
    t14 = <Box ref={ref} sx={t2}>{t13}</Box>;
    $[31] = ref;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  return t14;
}
function _temp(state) {
  return {
    handleClearFilters: state.handleClearFilters,
    handleApplyFilters: state.handleApplyFilters,
    selectedNonDefaultFilters: state.selectedNonDefaultFilters
  };
}